<div class="box">
  <div class="box-row header">
    <app-header-bar [title]="'software.title'"></app-header-bar>
  </div>
  <div class="d-flex flex-column flex-sm-row flex-wrap">
  @for(type of types(); track type.id) {
    <div class="card-wrapper">
      <div class="card">
        <div class="card-body d-flex flex-column justify-content-between">
          <div>
            <h3 class="card-title">
              <span>{{type.name}}</span>
            </h3>
            <p>{{type.description}}</p>
          </div>
          <div><a [routerLink]="['/software', 'type', type.id]" class="btn btn-primary">{{ 'software.show' | translate }}</a></div>
        </div>
      </div>
    </div>
  }
    <div class="card-wrapper">
      <div class="card">
        <div class="card-body d-flex flex-column justify-content-between">
          <div>
            <h3 class="card-title">
              <span>{{ 'configurations.nav' | translate }}</span>
            </h3>
            <p>{{ 'configurations.nav_description' | translate }}</p>
          </div>
          <div><a [routerLink]="['/software/configurations']" class="btn btn-primary">{{ 'software.show' | translate }}</a></div>
        </div>
      </div>
    </div>
  </div>
</div>
